module.exports = __webpack_public_path__ + "static/long-wheelbase-van-ea186a65e9c6af546cfdf9fe4043cbdb.jpg";